export default __webpack_public_path__ + "4d6c5704e16058c18732a26a83e03693.png";